"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerPaymentType = exports.PricePosition = exports.Language = exports.MeasurementUnits = void 0;
var MeasurementUnits;
(function (MeasurementUnits) {
    MeasurementUnits["METERS"] = "meters";
    MeasurementUnits["MILES"] = "miles";
})(MeasurementUnits = exports.MeasurementUnits || (exports.MeasurementUnits = {}));
var Language;
(function (Language) {
    Language["frfr"] = "fr-FR";
    Language["enus"] = "en-US";
    Language["engb"] = "en-GB";
    Language["eses"] = "es-ES";
})(Language = exports.Language || (exports.Language = {}));
var PricePosition;
(function (PricePosition) {
    PricePosition["BEFORE"] = "before";
    PricePosition["AFTER"] = "after";
})(PricePosition = exports.PricePosition || (exports.PricePosition = {}));
var PartnerPaymentType;
(function (PartnerPaymentType) {
    PartnerPaymentType["PREPAYMENT"] = "prepayment";
    PartnerPaymentType["LATEPAYMENT"] = "latepayment";
    PartnerPaymentType["DUAL"] = "dual";
})(PartnerPaymentType = exports.PartnerPaymentType || (exports.PartnerPaymentType = {}));
//# sourceMappingURL=tenant.js.map